export const REQUEST_LAYOUT_SETTINGS_CHANGE = "@LAYOUT/REQUEST_LAYOUT_SETTINGS_CHANGE";
export const REQUEST_DEFAULT_LAYOUT_SETTINGS_CHANGE = "@LAYOUT/REQUEST_DEFAULT_LAYOUT_SETTINGS_CHANGE";
export const SET_LAYOUT_SETTINGS = "@IF/SET_LAYOUT_SETTINGS";
export const SET_DEFAULT_LAYOUT_SETTINGS = "@IF/SET_DEFAULT_LAYOUT_SETTINGS";